module.exports = __webpack_public_path__ + "img/2025-0416-01-02.aebc3472.png";